import { GroupBase, StylesConfig } from 'react-select';
import { ISelectorOption } from 'types/ISelectorOption';
import { CSSObjectWithLabel } from 'react-select';

const formStyle: Partial<StylesConfig<ISelectorOption, boolean, GroupBase<ISelectorOption>>> = {
  menu: (provided: any): CSSObjectWithLabel =>
    ({
      ...provided,
      position: 'absolute',
      width: '100%',
      backgroundColor: 'rgba(0, 0, 0, 1)',
      borderColor: 'rgba(255, 255, 255, 1)',
      borderWidth: '1px',
      borderRadius: '5px',
      marginTop: '1px',
    } as CSSObjectWithLabel),
  menuList: (provided: any): CSSObjectWithLabel =>
    ({
      ...provided,
      color: 'rgba(255, 255, 255, 1)',
      textAlign: 'center',
      overflow: 'hidden',
      cursor: 'pointer',
    } as CSSObjectWithLabel),
  singleValue: (provided: any): CSSObjectWithLabel =>
    ({
      ...provided,
      color: 'var(--primary)',
      fontSize: '0.8rem',
      textAlign: 'center',
      fontWeight: 'bold',
      left: 0,
    } as CSSObjectWithLabel),
  valueContainer: (provided: any): CSSObjectWithLabel => ({
    ...(provided as CSSObjectWithLabel),
    justifyContent: 'center',
  }),
  option: (state: any): CSSObjectWithLabel => {
    const defaultControlStyles: CSSObjectWithLabel = {
      width: '100%',
      boxSizing: 'border-box',
      padding: '5px 0px',
      fontSize: '0.8rem',
      fontWeight: 'lighter',
    };
    const focusedControlStyles: CSSObjectWithLabel = {};
    const selectedControlStyles: CSSObjectWithLabel = {};

    if (state.isSelected) return selectedControlStyles;
    if (state.isFocused) return focusedControlStyles;

    return defaultControlStyles as CSSObjectWithLabel;
  },
  indicatorsContainer: (): CSSObjectWithLabel => ({
    color: 'var(--danger)',
  }),
  dropdownIndicator: (base: any) => ({
    ...base,
    color: 'var(--primary)',
    padding: 0,
  }),
  control: (state: any): CSSObjectWithLabel => {
    const defaultControlStyle: CSSObjectWithLabel = {
      alignItems: 'center',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      minHeight: 38,
      outline: '0 !important',
      position: 'relative',
      cursor: 'pointer',
    };

    const focusedControlStyles: CSSObjectWithLabel = {
      alignItems: 'center',
      backgroundColor: 'rgba(0, 0, 0, 1)',
      borderColor: 'rgba(255, 255, 255, 1)',
      borderRadius: 5,
      borderWidth: 1,
      boxShadow: '0 0 10px rgba(247, 148, 28, .1)',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      minHeight: 47,
      outline: '0 !important',
      position: 'relative',
      transition: 'all 100ms',
      boxSizing: 'border-box',
      width: '100%',
      cursor: 'pointer',
    };

    return state.isFocused ? focusedControlStyles : defaultControlStyle;
  },
};

export const errorStyles: Partial<
  StylesConfig<ISelectorOption, boolean, GroupBase<ISelectorOption>>
> = {
  option: (provided: any, state: any) => formStyle.option?.(provided, state) || {},
  control: () => {
    const controlHasErrorStyle: CSSObjectWithLabel = {
      alignItems: 'center',
      backgroundColor: 'hsl(0, 0%, 100%)',
      borderColor: '#ed4c78',
      borderRadius: 4,
      borderWidth: 1,
      boxShadow: '0 0 10px rgba(247, 148, 28, .1)',
      cursor: 'default',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      minHeight: 47,
      outline: '0 !important',
      position: 'relative',
      transition: 'all 100ms',
      boxSizing: 'border-box',
    };

    return controlHasErrorStyle;
  },
};

export default formStyle;
